
import '../Inscription.less';
import { Form, Input, InputNumber ,Button,Carousel, Layout,Menu , Row, Col,Upload,notification, message,Modal, Checkbox, Select,ConfigProvider, Divider, Collapse,Breadcrumb, Table     } from 'antd';
import { UploadOutlined,CheckOutlined, HomeOutlined,FileTextOutlined, MinusCircleOutlined, TeamOutlined,EyeInvisibleOutlined, EyeTwoTone, LockOutlined,MailOutlined, UserOutlined, LogoutOutlined, BarChartOutlined} from '@ant-design/icons';
import React, { Component, Fragment } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import validator from 'validator';
import moment from 'moment';
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import countries from '../static/json/countries.json'
import { Dropdown } from 'antd';
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import generatePDFPlaysByCountry from './services/reports'
import Navbar from '../components/NavBar'
 

class AdminHome extends Component {
  constructor(props){
    super(props)
    this.state={
      playsByCountry: [],
      todayP: 0,
      todayC: 0,
      totalC: 0,
      totalP: 0 ,
      conc_report:[],
      plays_report:[],
      reportCountry:null,
      makeCountryReport:false
    }
    
  }

getAuthors(auth){
  var authors = []
  for (var i in auth){
    authors.push({id:i,
      name: auth[i]["nombre_completo"]} )
  }
  return authors

 }
 getAuthorsStr(auth){
   var authors = []
   for (var i in auth){
    authors.push( auth[i]["nombre_completo"])
    
   }
  return authors

}
  
getCountryName(country){
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["code"]==country)
      return countries["countries"][c]["name_es"]
  }
  return "No name"
}

getCountryCode(country){
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["name_es"]==country)
      return countries["countries"][c]["code"]
  }
  return "No code"
}
  
  
async componentDidMount() {
  const plays = await fetch('https://back.premiocasa.cult.cu/api/musica/obra/',{
    method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"
  },
  });
  const json_plays = await plays.json();
  if(json_plays['detail']){
    localStorage.clear()
    window.location.reload(); 
  }
   
  const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc}))
  var data_play = []
  
  var data = []
  const Moment = require('moment');
  for(var i in json_plays){
    var item = json_plays[i];
    console.log(item)
    var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
    var author= this.getAuthors(item.conc)
    var a= this.getAuthorsStr(item.conc)
    
    
    var authorStr = this.getAuthorsStr(item.conc).join(", ")
    const year = date.split('-')[2]
    data_play.push(
        { 
            id : i,
            title : item.titulo,
            author: author ,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.id,
            conc:item.conc,
            // date:'',
            pdf:item.pdf,
            edit:''
        });
  };
    
    var conc_data = []
    for(var i in json_conc){
      var item = json_conc[i];
      conc_data.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: this.getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,

              // date:new Moment(item.start_publication).format('YYYY-MM-DD'),
              email: item.email,
          });
    };
    var todayP = 0
    var totalP = 0

    var todayC = 0
    var totalC = 0
    var playsByCountry={ }
    for(var key in json_plays){
      var play = json_plays[key]
      
      var country = play['conc'][0]['pais']
      var countryName =this.getCountryName(country)
      if(!(countryName in playsByCountry)){
        playsByCountry[countryName] ={"today":0,"total":0}
      }
      var playDate = moment(play.fecha_registro).format('DD-MM-YYYY')
      var today = moment().format('DD-MM-YYYY')

      if(today == playDate){
        todayP += 1
        playsByCountry[countryName]["today"] += 1
        for(var aut in play.conc){
          todayC +=1
        }
      }
      totalP += 1
      playsByCountry[countryName]["total"] += 1
      totalC += Object.keys(play.conc).length
    }
    this.setState({  
      conc_report: conc_data, 
      plays_report: data_play,
      playsByCountry: playsByCountry,
      todayP:todayP,
      todayC:todayC,
      totalC:totalC,
      totalP:totalP });
  }
  async logout(){
    console.log("LOGOUT")
    await fetch('https://back.premiocasa.cult.cu/api/logout',{
      method: "post",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    }).then(result=>{
      if(result.status == 200){
        localStorage.clear()
        window.location.reload(); 
      }
      else{
        notification.error({
      message:'Error',
      description:'Hubo un error, por favor intente más tarde',
    })}
    })
  }


  render() {
   
   
    const {  Footer, Content } = Layout;
   
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignElements:'center',
    };
    

const dataC = [
  {
    key: '1',
    todayC: this.state.todayC,
    totalC: this.state.totalC,
    
  },
];
const { Option } = Select;
var dataByCountry =  Object.keys(this.state.playsByCountry).map((country,index)=>
  {
    var row = {
      key:index,
      country:country,
      today:this.state.playsByCountry[country]["today"],
      total:this.state.playsByCountry[country]["total"]
    }
    return row
  })


const  data = dataByCountry.sort((a, b) => a.country.localeCompare(b.country))
const dataP = [
  {
    key: '1',
    todayP: this.state.todayP,
    totalP: this.state.totalP,
  }
];



const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")






const downloadConcReport =()=> generatePDFConc(this.state.conc_report,"save")
const readConcReport =()=> generatePDFConc(this.state.conc_report,"read")

const downloadPlayCountryReport =()=> generatePDFPlaysByCountry(data,"save")
const readPlayCountryReport =()=> generatePDFPlaysByCountry(data,"read")

const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save")
const readPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read")


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}

const { SubMenu } = Menu;
const { Column, ColumnGroup } = Table;
const menu = (
  <Menu mode={"inline"} style={{height:'140'}}>
      <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin"> Inicio</NavLink>
                </Menu.Item>
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/musicologia/admin_plays_list"> Obras</NavLink>
                </Menu.Item>
                <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/musicologia/admin_conc_list'> Concursantes  </NavLink>
                </Menu.Item>
            <SubMenu key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
                  



              <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
                 
                      
                 <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
                   <Menu.Item>
                       <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
                   </Menu.Item>
                 </Menu.ItemGroup>

                 <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>Por países</h4>}>
                  <Menu.Item>
                    <Button onClick={readPlayCountryReport}>Ver</Button> <Button onClick={downloadPlayCountryReport}>Descargar</Button>
                  </Menu.Item>
                </Menu.ItemGroup>

                <Menu.Item>
                    <h4 onClick={onClickCountryReport}  style={{  color:'black'}}>Por país específico</h4>
                  </Menu.Item>

                <Menu.Item style={{ fontWeight:'bold'}} >
                <h4 onClick={onClickGenreReport}  style={{  color:'black'}}>Por Genero</h4>
                  </Menu.Item>
         </SubMenu>
         <SubMenu  key="conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
           <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
             <Menu.Item>
               <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
             </Menu.Item>
           </Menu.ItemGroup>
         </SubMenu>
         
               
          </SubMenu>
          <SubMenu disabled key="jury" icon={<TeamOutlined  style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Jurado">
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado'> Todo  </NavLink>
            </Menu.Item>
            <Menu.Item>
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_poe'> Poesía  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_nov'> Novela  </NavLink>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
            <NavLink style={{fontSize:'16px', fontWeight:'bold'}} to='/musicologia/admin_jurado_ens'> Ensayo  </NavLink>
            </Menu.Item>
         </SubMenu>
                 
          <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
          <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold', font:'black'}}> Cerrar sesión </a>
          </Menu.Item>
    </Menu>
  
)


    return (
      
 
      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/musicologia"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          

          </Row>
          
          <Row>
            <Col span={24}>
            <Navbar menu={menu}/>

            
            </Col>
          </Row>
          <Content>
            
{/*          
            <Carousel autoplay >
            <div>
      <h3 style={contentStyle}>Obras:{this.state.plays}</h3>
    </div>
    <div>
      <h3 style={contentStyle}>Concursantes:{this.state.conc}</h3>
    </div>
    
              </Carousel> */}
              <Row  justify="center" align="middle" >

              <Col span={24}>
                <br></br>
                <Table bordered dataSource={dataP} pagination={false} size='small' style={{fontSize:'large'}} >
                    <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/musicologia/admin_plays_list">Obras</NavLink> </div>}>
                   
                      <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayP" key="todayP" align='center' render = {(text,record)=> {
                        return {
                          props: {
                            style: { background:  "white",fontSize:'large' }
                          },
                          children: <div>{text}</div>
                        }} } />
                      <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)}dataIndex="totalP" key="totalP"  align='center'render = {(text,record)=> {
                        return {
                          props: {
                            style: { background: "white",fontSize:'large' }
                          },
                          children: <div>{text}</div>
                        }} } />
                    </ColumnGroup>
                  </Table>
                  <br/>
                  <Row  justify="center" align="middle"  >
             
                    <Col span={24} >
                      
                      <Table  bordered dataSource={dataC} pagination={false}size='small' >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/musicologia/admin_conc_list">Concursantes</NavLink></div>}>
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayC" key="todayC" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background:  "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)} dataIndex="totalC" key="totalC" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background:  "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                        </ColumnGroup>
                      </Table>
                    </Col>
             
                  </Row>
                </Col>

                <Col span={24}>
                  <br></br>
                  <Table bordered dataSource={data} pagination={false} size='small' style={{fontSize:'large'}} >
                    <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/musicologia/admin_plays_list">Obras</NavLink> </div>}>
                    <Column
                      title={(<div style={{ fontWeight:'bold', fontSize:'x-large'}}> País</div>)} 
                      dataIndex="country" key="country" align='center'
                      render = {(text,record)=> {
                          return {
                            props: {
                              style: { background: "white",fontSize:'large' }
                            },
                            children: <div>{text}</div>
                          }} }
                       
                    />
                    <Column title={(<div style={{  fontSize:'large'}}>Hoy</div>)} dataIndex={"today" } key="today" align='center' render = {(text,record)=> {
                      return {
                        props: {
                          style: { background:"white",fontSize:'large' }
                        },
                        children: <div>{text}</div>
                      }} } 
                    />
                    <Column title={(<div style={{ fontSize:'large'}}>Total</div>)}dataIndex={"total" } key="total"  align='center'render = {(text,record)=> {
                      return {
                        props: {
                          style: { background:  "white",fontSize:'large' }
                        },
                        children: <div>{text}</div>
                      }} } />
                    </ColumnGroup>
                  </Table>
                  <br/>
                </Col>
              </Row>

              {this.state.makeGenreReport &&
              <Modal
              closable = {false}
              title="Reporte por género"
              visible={this.state.makeGenreReport}
              footer={[
                <Button key="back" onClick={onClosekGenreReport}>
                Regresar
                </Button>,
            ]}
              >
             
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportGenre}
                   onChange={onChangeReportGenre}
                   >
                    {Object.entries(this.state.genres).map(element => {console.log("RRRRRRR",element);return <Option value={element[1].nombre}>{this.getCountryName(element[1].nombre)}</Option>})}
                  </Select>
                  <div>
                    <br/>
                  <Button onClick={readPlayReportGenre}>Ver</Button> <Button onClick={downloadPlayReportGenre}>Descargar</Button>

                  </div>
               

              </Modal>}

              {this.state.makeCountryReport &&
              <Modal
              closable = {false}
              title="Reporte por país"
              visible={this.state.makeCountryReport}
              footer={[
                <Button key="back" onClick={onClosekCountryReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportCountry}
                   onChange={onChangeReportCountry}
                   >
                    {Object.entries(data).map(element => {console.log("RRRRRRR",element);return <Option value={element[1].country}>{element[1].country}</Option>})}
                  </Select>
                  <div>
                    <br/>
                    <Button onClick={readPlayReportSelectedCountry}>Ver</Button> <Button onClick={downloadPlayReportSelectedCountry}>Descargar</Button>
                  </div>
              </Modal>}
          </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Footer style={{backgroundColor:'#ed7e8e', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
      <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ed7e8e',  marginBottom:'0px', bottom:'0px'}}>
        <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/musicologia/admin_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
        <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
        <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
        <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
        <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/musicologia/admin_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
      </Row>
    </Footer>
    </div>

    );
  }
}
export default AdminHome;


